"use client";

import type { SchoolData } from "@nimble/candidate-api/types";

import {
  SchoolCardActionsDesktopContainer,
  SchoolCardActionsMobileContainer,
} from "@/components/shared/school/school-card/school-card-actions.container";
import SchoolCardHeaderRow from "@/components/shared/school/school-card-header-row";
import SchoolContentBody from "@/components/shared/school/school-content-body";
import { SchoolDetailsHeaderCompact } from "@/components/shared/school/school-details/school-details-header";
import { SchoolLinkTarget } from "@/components/shared/school/school-details/school-name-link";
import SchoolJobPostings from "@/components/shared/school/school-job-postings";
import ViewSchoolPageButton from "@/components/shared/school/view-school-page-button";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { StateConfig } from "@/lib/states-config";

interface MobileSchoolDetailsViewProps {
  school: SchoolData;
  stateConfig: StateConfig;
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileSchoolDetailsView({
  school,
  stateConfig,
  isOpen,
  onClose,
}: MobileSchoolDetailsViewProps) {
  return (
    <Drawer open={isOpen} onOpenChange={onClose}>
      <DrawerContent className="max-h-[70vh] p-0">
        <div className="flex flex-col">
          <div className="flex-1 overflow-y-auto px-4 py-3">
            <SchoolContentBody
              schoolData={school}
              header={
                <SchoolCardHeaderRow
                  actions={
                    <SchoolCardActionsDesktopContainer
                      schoolData={school}
                      stateConfig={stateConfig}
                    />
                  }
                  mobileActions={
                    <SchoolCardActionsMobileContainer
                      schoolData={school}
                      stateConfig={stateConfig}
                    />
                  }
                >
                  <SchoolDetailsHeaderCompact
                    schoolData={school}
                    schoolLinkTarget={SchoolLinkTarget.SameTab}
                    stateConfig={stateConfig}
                  />
                </SchoolCardHeaderRow>
              }
              postings={
                <SchoolJobPostings
                  schoolData={school}
                  stateConfig={stateConfig}
                />
              }
              viewButton={
                <ViewSchoolPageButton
                  schoolData={school}
                  stateConfig={stateConfig}
                />
              }
            />
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
